import {Modal} from "antd";
import React, {forwardRef, useImperativeHandle, useState} from "react";

/**
 * @author: Yaochao
 * @date: 2021-07-02 16:53
 * @description：模态框组件封装
 */

const ZkModal = forwardRef((zprops, ref) => {
    const [visible, setVisible] = useState(false);
    const props = {visible: visible, ...zprops};
    props.visible = visible;
    let onCancel = props.onCancel;
    let onOk = props.onOk;
    props.onCancel = cancel;
    props.onOk = ok;

    useImperativeHandle(ref, () => ({
        show: show,
        hide: hide
    }));

    //显示模态框
    function show() {
        setVisible(true)
    }

    //隐藏模态框
    function hide() {
        setVisible(false)
    }

    function cancel() {
        if (onCancel) {
            onCancel();
        } else {
            hide();
        }
    }

    function ok() {
        if (onOk) {
            onOk();
        } else {
            hide();
        }
    }

    return (
        <Modal {...props}>
        </Modal>
    )
});

export default ZkModal